import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'

const Footer = () => {
  return (
    <footer className="footer footer-five">
  {/* Footer Top */}
  <div className="footer-three-top" data-aos="fade-up">
    <div className="container">
      <div className="footer-three-top-content">
        <div className="row align-items-center gy-4">
          <div className="col-lg-6">
            {/* Footer Widget */}
            <div className="footer-widget-three footer-about">
              <div className="footer-three-logo">
                <ImageWithBasePath
                  className="img-fluid"
                  src="assets/img/logo-white.svg"
                  alt="logo"
                />
              </div>
              <div className="footer-three-about">
                <p>
                  Platform designed to help organizations, educators, and
                  learners manage,
                </p>
              </div>
              <div className="box-form-newsletter">
                <form className="form-newsletter">
                  <input
                    className="input-newsletter"
                    type="text"
                    placeholder="Enter your email here"
                  />
                  <button className="btn btn-secondary font-heading icon-send-letter">
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
            {/* /Footer Widget */}
          </div>
          <div className="col-lg-6">
            <div className="row gy-4">
              <div className="col-md-6 d-lg-flex justify-content-end">
                {/* Footer Widget */}
                <div className="footer-widget-three footer-menu-three footer-three-right">
                  <h5 className="footer-three-title">For Instructor</h5>
                  <ul>
                    <li>
                      <Link to={all_routes.instructorProfile}>Profile</Link>
                    </li>
                    <li>
                      <Link to={all_routes.login}>Login</Link>
                    </li>
                    <li>
                      <Link to={all_routes.register}>Register</Link>
                    </li>
                    <li>
                      <Link to={all_routes.instructorList}>Instructor</Link>
                    </li>
                    <li>
                      <Link to={all_routes.instructorDashboard}> Dashboard</Link>
                    </li>
                  </ul>
                </div>
                {/* /Footer Widget */}
              </div>
              <div className="col-md-6 d-lg-flex justify-content-end">
                {/* Footer Widget */}
                <div className="footer-widget-three footer-menu-three">
                  <h5 className="footer-three-title">For Student</h5>
                  <ul>
                    <li>
                      <Link to={all_routes.studentProfile}>Profile</Link>
                    </li>
                    <li>
                      <Link to={all_routes.login}>Login</Link>
                    </li>
                    <li>
                      <Link to={all_routes.register}>Register</Link>
                    </li>
                    <li>
                      <Link to={all_routes.studentsList}>Student</Link>
                    </li>
                    <li>
                      <Link to={all_routes.studentDashboard}> Dashboard</Link>
                    </li>
                  </ul>
                </div>
                {/* /Footer Widget */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Footer Top */}
</footer>

  )
}

export default Footer